import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Card, CardHeader, CardContent, CardActions, Grid, Typography, Button, FormControl, Select, MenuItem, ButtonGroup } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from "react-chartjs-2";
import { withTranslation, WithTranslation } from 'react-i18next';
import { LocalShippingOutlined, PeopleOutlined, PaymentsOutlined, DeleteSweepOutlined, KeyboardArrowLeftRounded } from '@mui/icons-material';
import OperationsHeader from './OperationsHeader';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
    };
}

export interface IState {
    regularCheckupDataBar: any;
    regularCheckupBarChartOptions: any;
    reparationWorkDataBar: any;
    reparationWorkBarChartOptions: any;
    vehicleCostDataBar: any;
    vehicleCostBarChartOptions: any;
}

class VehicleCharts extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            regularCheckupDataBar: {
                labels: ["3 Years", "2 Years", "1 Year", "6 Months", "3 Months"],
                datasets: [
                    {
                        label: 'Time',
                        data: [1, 3, 5, 4, 2],
                        backgroundColor: 'rgba(32, 77, 54, 0.8)',
                        borderWidth: 2,
                        borderColor: 'rgba(32, 77, 54, 1)'
                    }
                ]
            },
            regularCheckupBarChartOptions: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top' as const,
                        rotate: '90'
                    },
                    title: {
                        display: true,
                        text: 'Time since regular check up performed',
                    },
                }
            },
            reparationWorkDataBar: {
                labels: ["Tyres Replaces", "Coolant Repaired", "Breaks Repaired", "Sling Cable Repaired", "Others Repaired"],
                datasets: [
                    {
                        label: 'Work',
                        data: [0, 3, 2, 1, 4],
                        backgroundColor: 'rgba(32, 77, 54, 0.8)',
                        borderWidth: 2,
                        borderColor: 'rgba(32, 77, 54, 1)'
                    }
                ]
            },
            reparationWorkBarChartOptions: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top' as const,
                    },
                    title: {
                        display: true,
                        text: 'Repetations work in Last 6 months',
                    },
                }
            },
            vehicleCostDataBar: {
                labels: ["Jan","Feb","Mar"],
                datasets: [
                    {
                        label: 'Time',
                        data: [1, 3, 5],
                        backgroundColor: 'rgba(32, 77, 54, 0.8)',
                        borderWidth: 2,
                        borderColor: 'rgba(32, 77, 54, 1)'
                    }
                ]
            },
            vehicleCostBarChartOptions: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top' as const,
                        rotate: '90'
                    },
                    title: {
                        display: true,
                        text: 'Vehicle Cost',
                    },
                }
            }
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        return (
            <div>
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                avatar={
                                    <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/operations/maintenance'}><KeyboardArrowLeftRounded /></Button>
                                }
                                title="Vehicle Charts"
                                className="text-left"
                            />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12}>
                                        <Card sx={{ boxShadow: 3 }}>
                                            <CardHeader
                                                title="Vehicle Charts"
                                                className="text-left"
                                            />
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={4} xs={12}>
                                                        <Bar data={this.state.regularCheckupDataBar} options={this.state.regularCheckupBarChartOptions} height={300} />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <Bar data={this.state.reparationWorkDataBar} options={this.state.reparationWorkBarChartOptions} height={300} />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <Bar data={this.state.vehicleCostDataBar} options={this.state.vehicleCostBarChartOptions} height={300} />
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(VehicleCharts))